import React, { useEffect, useState } from 'react';
import { Plus, Users, Edit, Trash2, RefreshCw } from 'lucide-react';
import { fetchTeams, deleteTeam, selectTeams, selectTeamLoading } from '../../store/slices/teamSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import TeamForm from './TeamForm';
import PopupComponent from '../../components/PopupComponent';

const TeamsList: React.FC = () => {
  const dispatch = useAppDispatch();
  const teams = useAppSelector(selectTeams);
  const loading = useAppSelector(selectTeamLoading);
  const [showForm, setShowForm] = useState(false);
  const [editingTeam, setEditingTeam] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchTeams({ page: 1, perPage: 50 }));
  }, [dispatch]);

  const handleCreateTeam = () => {
    setEditingTeam(null);
    setShowForm(true);
  };

  const handleEditTeam = (team: any) => {
    setEditingTeam(team);
    setShowForm(true);
  };

  const handleDeleteTeam = async (teamId: string) => {
    if (window.confirm('Are you sure you want to delete this team?')) {
      await dispatch(deleteTeam(teamId));
      dispatch(fetchTeams({ page: 1, perPage: 50 }));
    }
  };

  const handleRefresh = () => {
    dispatch(fetchTeams({ page: 1, perPage: 50 }));
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingTeam(null);
    dispatch(fetchTeams({ page: 1, perPage: 50 }));
  };


  return (
    <div className="teams-list-container">
      <div className="teams-list-header">
        <h3>Teams ({teams?.length || 0})</h3>
        <div className="teams-actions">
          <button
            className="btn-refresh"
            onClick={handleRefresh}
            disabled={loading?.teams}
          >
            <RefreshCw size={14} className={loading?.teams ? 'spinning' : ''} />
          </button>
          <button className="btn-primary" onClick={handleCreateTeam}>
            <Plus size={14} />
            Create Team
          </button>
        </div>
      </div>

      {loading?.teams ? (
        <div className="loading-grid">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="team-card loading">
              <div className="loading-placeholder"></div>
            </div>
          ))}
        </div>
      ) : (
        <div className="teams-grid">
          {teams?.length === 0 ? (
            <div className="empty-state">
              <Users size={64} />
              <h4>No teams found</h4>
              <p>Organize your workspace by creating teams to group members and manage collaboration</p>
              <button className="btn-primary" onClick={handleCreateTeam}>
                <Plus size={16} />
                Create Your First Team
              </button>
            </div>
          ) : (
            teams?.map((team) => (
              <div key={team._id} className="team-card">
                <div className="team-card-header">
                  <div className="team-icon">
                    <Users size={24} />
                  </div>
                  <div className="team-card-content">
                    <h4 className="team-name">{team.name}</h4>
                    <p className="team-stats">
                      {team.totalTeamMembers || 0} members
                    </p>
                  </div>
                  <div className="team-actions">
                    <button
                      className="btn-icon"
                      onClick={() => handleEditTeam(team)}
                      title="Edit team"
                    >
                      <Edit size={16} />
                    </button>
                    <button
                      className="btn-icon btn-danger"
                      onClick={() => handleDeleteTeam(team._id || '')}
                      title="Delete team"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
                {team.createdBy && (
                  <div className="team-card-footer">
                    <p className="team-creator">Created by: {team.createdBy}</p>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      )}

      {/* Team Form Popup */}
      <PopupComponent
        isOpen={showForm}
        onClose={handleFormClose}
        title={editingTeam ? 'Edit Team' : 'Create New Team'}
        size="md"
      >
        <TeamForm team={editingTeam} onClose={handleFormClose} />
      </PopupComponent>
    </div>
  );
};

export default TeamsList;